import React from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {Alert, Platform, useWindowDimensions, View} from 'react-native';
import {calculateDistance} from 'src/Utils/distanceHelpers';
import {TextLine, DealCard} from 'src/Modules/CommonView';

import {askForHuntInvite} from '../../Utils/huntInviteFunctions';
import {Linking} from 'react-native';
import moment from 'moment';

import {HeaderAndCarouselView} from '../../Modules/CommonView/HeaderAndCarouselView';
import {navigationRef} from 'src/Nav/navigationHelpers';
import {useUserId} from '../../Hooks/reduxHooks';
import {cloudFlareOptimizeImage} from '../../Utils/helpers';
import {setEventId} from '../../Redux/reducers/event.reducer';

const HomeNearbyGroupFinder = ({joinPage = false}) => {
  const dispatch = useDispatch();

  const {width} = useWindowDimensions();

  const eventId = useSelector((state) => state.event?.eventId);
  const playTestState = useSelector((state) => state.app_info?.playTestState);
  const region = useSelector((state) => state.location?.region);
  const hasGPSLocationData = useSelector(
    (state) => state.location?.hasGPSLocationData,
  );
  const {latitude, longitude} = region;
  const nearbyGroups = useSelector((state) => state.nearby?.nearbyGroups);

  const userId = useUserId();

  if (playTestState) {
    return <View />;
  }

  if (!hasGPSLocationData && !joinPage && Platform.OS != 'web') {
    return (
      <View>
        <DealCard
          resizeMode={'contain'}
          imageSource={{
            uri: cloudFlareOptimizeImage(
              'https://photos.letsroam.com/photos_other/scavenger-hunt-location-1648579695_medium.jpg',
            ),
          }}
          handlePress={() => Linking.openSettings()}
          title={'Warning: Location services are OFF'}
          description={`Please enable location permissions by clicking here, so we can find nearby hunts for you to do and guide you from location to location. Without location services the app will not work as expected.`}
          allowLongText
        />
      </View>
    );
  }

  if (!nearbyGroups) {
    return <View />;
  }

  const nearbyEvents = [];
  let filteredNearbyGroups = [];

  if (!window?.location?.href?.includes('isDemo')) {
    nearbyGroups?.map?.((nearbyGroup) => {
      // checking if inactive

      if (!nearbyGroup.isCorporateEvent) {
        if (nearbyGroup.createdBy == userId || !nearbyGroup?.createdByName) {
          return;
        }

        if (
          !nearbyGroup?.lastActive ||
          (Date.now() - nearbyGroup?.lastActive) / 1000 > 30 * 60
        ) {
          return false;
        }
      }
      const distanceAway = calculateDistance(
        nearbyGroup.lat,
        nearbyGroup.long,
        latitude,
        longitude,
        'MILES',
      );
      console.log({distanceAway});
      // only showing hunts that want to be discovered within 3 miles
      if (distanceAway < 5 && nearbyGroup.discoverable) {
        filteredNearbyGroups.push({
          ...nearbyGroup,
          type: 'group_card',
          distanceAway: Math.round(distanceAway * 10) / 10,
          handlePress: () => {
            if (!userId) {
              global.devAlert('Error: No User Id');
              return navigationRef.navigate('LoginModal', {
                message: 'You must log in to use this feature',
              });
            }
            console.log('group_card pressed', nearbyGroup?.groupId);
            navigationRef.navigate('ConfirmModal', {
              titleText: `Are you sure you want to ask to join ${nearbyGroup?.createdByName} group`,
              titleBodyText:
                'Only invite your friends, family, and people you know to play. Spamming invites will get you banned.',
              confirmText: `Ask ${nearbyGroup?.createdByName} To Play`,
              backgroundColor: global.color.black_70,

              cancelText: 'Cancel',
              handleConfirm: (closeModal) => {
                askForHuntInvite(nearbyGroup, nearbyGroup?.createdBy);
                closeModal();
              },
            });
          },
        });
      }

      if (nearbyGroup.isCorporateEvent) {
        nearbyEvents.push({
          ...nearbyGroup,
          type: 'event_card',
        });
      }
    });
  } else if (window?.location?.search) {
    // is demo
    const urlParams = new URLSearchParams(window.location.search);
    const startingLocation = urlParams.get('startingLocation');
    const company = urlParams.get('company');
    const companyURL = urlParams.get('companyURL');
    const logoURL = `https://logo.clearbit.com/${companyURL}?size=800`;
    console.log({logoURL});
    nearbyEvents.push({
      company: company || 'Your Company',
      eventDate: moment().format('MM/DD'),
      startingLocation: startingLocation,
      type: 'event_card',
      brandingPhoto: companyURL
        ? logoURL
        : cloudFlareOptimizeImage(
            'https://photos.letsroam.com/photos_other/scavenger-hunt-location-1648578460_medium.jpg',
          ),
    });
  }
  // global.devAlert(nearbyEvents);

  if (!filteredNearbyGroups?.[0] && !nearbyEvents?.[0]) {
    return <View />;
  }

  filteredNearbyGroups = filteredNearbyGroups?.sort((a, b) => {
    return a.lastActive < b.lastActive ? 1 : -1;
  });

  return (
    <View style={{marginBottom: 10}}>
      {joinPage && (
        <View style={{paddingTop: 20, paddingBottom: 10}}>
          <TextLine
            text={'OR'}
            containerStyle={{marginTop: 10, minWidth: 100}}
          />
        </View>
      )}
      {nearbyEvents?.map?.((nearbyEvent, index) => {
        const alreadyJoined = eventId == nearbyEvent?.eventId;
        var image = nearbyEvent?.brandingPhoto || nearbyEvent?.huntPhoto;
        if (nearbyEvent?.category?.includes('bach')) {
          image = cloudFlareOptimizeImage(
            'https://photos.letsroam.com/photos_other/scavenger-hunt-location-1648578550_large.jpg',
          );
        }
        if (image == 'https://photos.letsroam.com/scavenger_hunt_locations/') {
          image = cloudFlareOptimizeImage(
            'https://photos.letsroam.com/photos_other/scavenger-hunt-location-1648577343_medium.jpg',
          );
        }
        console.log({nearbyEvent});

        return (
          <View key={index + nearbyEvent?.eventId} style={{minHeight: 100}}>
            <DealCard
              imageSource={{
                uri: image,
              }}
              resizeMode={Platform.OS == 'web' ? 'contain' : 'cover'}
              imageHeight={240}
              imageStyle={Platform.OS == 'web' ? {width: width} : {}}
              imageContainerStyle={
                Platform.OS == 'web'
                  ? {
                      display: 'flex',
                      justifyContent: 'center',
                      alignItems: 'center',
                      alignContent: 'center',
                      backgroundColor: global.color.gray1,
                    }
                  : {}
              }
              overlayText={`Custom Event For ${nearbyEvent?.company}\n\nDate: ${nearbyEvent?.eventDate}`}
              showOverlay={!nearbyEvent?.brandingPhoto}
              containerStyle={{
                borderColor: global.color.orange,
                borderWidth: 1,
                ...global?.style.boxShadow,
              }}
              titleStyle={{textDecorationLine: 'underline', lineHeight: 22}}
              overlayTextStyle={{
                fontSize: 22,
                lineHeight: 26,
                textAlign: 'center',
                fontFamily: global.font.circularBold,
              }}
              overlayTextContainerStyle={{
                backgroundColor: global.color.gray3_60,
              }}
              handlePress={() => {
                const formatCode = (code = '') => {
                  return code
                    ?.toString?.()
                    ?.toLowerCase?.()
                    ?.trim?.()
                    ?.replace?.(/\s/g, '');
                };
                const joinEvent = () => {
                  dispatch(setEventId(nearbyEvent?.eventId));
                  navigationRef.navigate('EventHome');
                };

                if (window?.location?.href?.includes('isDemo')) {
                  return joinEvent();
                }

                if (alreadyJoined) {
                  return joinEvent();
                }
                navigationRef.navigate('ConfirmModal', {
                  titleText: `${alreadyJoined ? 'Rejoin' : 'Join'} ${
                    nearbyEvent?.company
                  } Custom Event`,
                  titleBodyText:
                    `To join this event either enter the join code for the event or the first name of the event organizer.` +
                    (__DEV__ ? '\nDev:' + JSON.stringify(nearbyEvent) : ''),
                  placeholder: 'Join Code or Organizer First Name',
                  confirmText: 'Join Event',
                  cancelText: 'Cancel',
                  showPrompt: 1,
                  handleConfirm: (promptText, handleDone) => {
                    const formattedPrompt = formatCode(promptText || 'errorss');
                    const codes = [
                      formatCode(nearbyEvent?.joinCode),
                      formatCode(nearbyEvent?.eventId),
                      formatCode(nearbyEvent?.organizerName),
                    ];
                    // global.devAlert(codes);
                    if (codes?.includes(formattedPrompt)) {
                      handleDone();
                      joinEvent();
                    } else {
                      Alert.alert('Incorrect Code', 'Your code did not match.');
                    }
                  },
                });
              }}
              allowLongText
              title={`${alreadyJoined ? 'Rejoin' : 'Join'} Custom Event For ${
                nearbyEvent?.company
              } >>`}
              description={`There is an event for ${nearbyEvent?.company} on ${nearbyEvent?.eventDate}. \nStarting Location: ${nearbyEvent?.startingLocation}\n\n`}
            />
          </View>
        );
      })}
      {filteredNearbyGroups?.[0] && (
        <HeaderAndCarouselView
          type={'group_card'}
          data={filteredNearbyGroups}
          buttonText={!joinPage ? 'Search By Join Code >' : null}
          buttonPress={() => {
            navigationRef.navigate('JoinLanding');
          }}
          title={
            joinPage ? 'Join nearby groups' : `Find Friend's Groups Nearby`
          }
        />
      )}
    </View>
  );
};

export default HomeNearbyGroupFinder;
